import { State } from "..";

export const getFaqList = (state: State) => state.faq.loadFaq?.success;
export const getLoadFaqReqInfo = (state: State) => state.faq.loadFaq;
export const getModalContent = (state: State) => state.faq.modalContent;
